<template>
  <label
    class="base-input"
    :class="{ 'base-input--loneliness': uiType === 'loneliness', 'base-input--loneliness-error': error }"
    for="email"
  >
    <span
      v-if="label"
      :class="['base-input__label', { 'base-input__label-error': error }]"
    >
      {{ label }}
    </span>
    <input
      :value="modelValue"
      class="base-input__input"
      :class="{
        'base-input__input-error': error,
        'base-input__input-icon': iconName,
        'base-input__input-disabled': disabled,
        'base-input__input-loneliness': uiType === 'loneliness',
      }"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      @focus="emits('on-focus')"
      @blur="emits('on-blur')"
    >
    <nuxt-icon
      v-if="iconName"
      :name="iconName"
      class="base-input__icon"
      filled
    />
  </label>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  type: {
    type: String,
    default: 'email',
  },
  iconName: {
    type: String,
  },
  error: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: String,
  uiType: {
    type: String,
    default: 'default',
  },
});

const emits = defineEmits(['update:modelValue', 'on-focus', 'on-blur']);

function onInput({ target }: Event): void {
  emits('update:modelValue', (target as HTMLInputElement).value);
}
</script>

<style lang="scss" scoped>
.base-input {
  position: relative;
  display: block;
  text-align: center;
  margin: 0 auto;
  width: 100%;

  &__icon {
    position: absolute;
    top: 8px;
    right: 20px;
    font-size: 32px;
    color: $text-color;
  }

  &__input {
    background: $gray-bg;
    border-radius: 9px;
    font-size: 16px;
    padding: 14px 20px;
    width: 100%;
    position: relative;
    border: 2px solid transparent;
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    appearance: none;
    transition-duration: .15s;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.04) inset;
    height: 53px;

    &:focus, &:active {
      outline: none;
    }
  }

  &__input-error {
    color: $red !important;
    border: 2px solid $red;
  }

  &__input-icon {
    padding-right: 40px;
  }

  &__input-disabled {
    box-shadow: unset;
    background: #F9F9F9;
  }

  &--loneliness {
    display: flex;
    align-items: center;
    text-align: left;

    .base-input__input {
      background: #FFFCF2;
      border-radius: 20px;
      border: 1.5px solid rgba(45, 45, 45, 0.20);
      box-shadow: none;
      padding: 16px;
      height: 52px;
      font-size: 15px;
      color: #2D2D2D;

      &:focus {
        border-color: #2D2D2D;
      }

      &::placeholder {
        color: rgba(45, 45, 45, 0.40);;
      }
    }

    .base-input__label {
      position: absolute;
      top: -10px;
      left: 18px;
      background: #FFFCF2;;
      z-index: 1;
      pointer-events: none;
      color: #2D2D2D;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.24px;
      padding: 0 2px;
    }

    .base-input__icon {
      top: unset;
      font-size: 20px;
      right: 16px;
    }
  }

  &--loneliness-error {

    .base-input__label-error {
      color: #FA4519;
    }
    .base-input__input-error {
      border-color: #FA4519;
      color: #FA4519 !important;

      &:focus {
        border-color: #FA4519;
      }

      &::placeholder {
        color: rgba(250, 69, 25, 0.50);
      }
    }

    .base-input__icon {
      color: #FA4519;

      :deep(svg) {
        path {
          stroke: #FA4519;
        }
      }
    }
  }
}
</style>
